@defer (when agReady()) {
  <ag-grid-angular
    style="width: 100%; height: 100%"
    [gridOptions]="gridOptions()"
    [columnDefs]="columnDefs()"
    [defaultColDef]="defaultColDef()"
    [autoGroupColumnDef]="autoGroupColumnDef()"
    [rowData]="rowData()"
    [loading]="loading()"
    (gridReady)="onGridReady($event)"
    (firstDataRendered)="onFirstDataRendered($event)"
    (rowDataUpdated)="syncCheckboxSelection()"
    (columnVisible)="onColumnVisible()"
    (columnMoved)="persistColumnState()"
    (columnResized)="persistColumnState()"
    (columnPinned)="persistColumnState()"
    (sortChanged)="persistColumnState()"
    (rowClicked)="onRowClicked($event)"
    (rowDoubleClicked)="rowDoubleClicked.emit($event.data)"
    (rowValueChanged)="onRowValueChanged($event)"
    (cellValueChanged)="onCellValueChanged($event)"
    (cellKeyDown)="onCellKeyDown($event)"
    (selectionChanged)="onSelectionChanged($event)"
    (cellFocused)="onCellFocused($event)"
    [theme]="theme"
  />
}
